import { UnfoldLessOutlined, UnfoldMoreOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import Flx from "../../layout/Flx";

/**
 * Expand-all / collapse-all pair for a sidebar's card stack. Pass the
 * `signalCards` callback from the host, which bumps the token its
 * `PanelCardCollapseProvider` hands down to every PanelCard beneath it.
 *
 * Labelled rather than icon-only — these sit next to a search field where a
 * bare chevron pair reads as a sort or a stepper.
 */
const CardCollapseButtons = ({ onSignal }) => (
  <Flx ac g={0.5} sx={{ flexShrink: 0 }}>
    <Button
      size="small"
      variant="text"
      startIcon={<UnfoldMoreOutlined sx={{ fontSize: "16px !important" }} />}
      onClick={() => onSignal(true)}
      sx={{ textTransform: "none", fontSize: 11.5, minWidth: 0, px: 1 }}
    >
      Expand
    </Button>
    <Button
      size="small"
      variant="text"
      startIcon={<UnfoldLessOutlined sx={{ fontSize: "16px !important" }} />}
      onClick={() => onSignal(false)}
      sx={{ textTransform: "none", fontSize: 11.5, minWidth: 0, px: 1 }}
    >
      Collapse
    </Button>
  </Flx>
);

export default CardCollapseButtons;
